import { Link } from "react-router-dom";
import PageMeta from "../../components/common/PageMeta";

export default function About() {
  return (
    <>
      <PageMeta
        title="このサイトについて"
        description="ChatoraHack Lotteryは、日本の数字選択式宝くじの当選番号・払戻金を公開し、配当金と出目の関係など過去データの統計的な分析・研究を行う無料の情報サイトです。当選予想・攻略ツールではなく、宝くじの販売・購入代行や個人情報の入力もありません。"
        path="/about"
        breadcrumbs={[
          { name: "TOP", path: "/" },
          { name: "このサイトについて", path: "/about" },
        ]}
      />
      <div className="mx-auto mb-8">
        <div className="flex justify-between items-center flex-wrap mb-8 border-b border-b-2 border-primary-500 pb-2">
          <h1 className="text-2xl font-bold text-primary-500">
            このサイトについて
          </h1>
        </div>
        <div className="p-8 bg-base-50 rounded-3xl">
          <section className="mb-8">
            <p className="text-gray-800 text-sm leading-relaxed">
              ChatoraHack Lotteryは、日本の数字選択式宝くじ（ロト6・ロト7・ミニロト・ナンバーズ3・ナンバーズ4・ビンゴ5・着せかえクーちゃん）の抽選結果・当選番号・［ 払戻金 ］を公開し、「どんな出目のときに配当金が高くなるのか」など、過去データの統計的な分析・研究を行う無料の情報サイトです。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-bold text-primary-500 mb-4">サイト名の「Hack」について</h2>
            <p className="text-gray-800 text-sm leading-relaxed">
              「ChatoraHack」は「チャレンジ＆トライ（Chatora）して世の中をより良くする Hack」に由来するブランド名です。ここでの「Hack」は<strong>公開されているデータを読み解く研究・分析の工夫（ライフハック）</strong>という前向きな意味で使っており、不正アクセス・クラッキング・チート・当選予想・攻略といった意味は一切含みません。当サイトは宝くじの当選確率を操作したり、当選を予想・保証したりするものではありません。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-bold text-primary-500 mb-4">サービスの位置づけ</h2>
            <ul className="text-gray-800 text-sm leading-relaxed list-disc pl-5 space-y-1">
              <li>公表済みの抽選結果を整理・公開し、過去データの統計分析・考察（配当金と出目の関係など）を発表する研究・情報サイトです。</li>
              <li>当選番号の予想、必勝法、当選を保証するツールの提供は行いません。</li>
              <li>宝くじの販売、購入代行、投資勧誘なども一切行いません。</li>
              <li>個人情報・ログイン情報・決済情報を入力する項目はありません（会員登録もありません）。</li>
              <li>掲載しているデータは非公式です。当選確認は必ず公式（みずほ銀行等）の発表で行ってください。</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-bold text-primary-500 mb-4">データについて</h2>
            <p className="text-gray-800 text-sm leading-relaxed">
              各くじの全回分の当選番号・［ 払戻金 ］・販売実績・キャリーオーバーを収録し、抽選日の翌日に自動更新しています。詳しくは<Link to="/terms" className="text-primary-500 underline hover:no-underline">免責事項</Link>をご確認ください。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-bold text-primary-500 mb-4">運営</h2>
            <p className="text-gray-800 text-sm">ChatoraHack</p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-bold text-primary-500 mb-4">お問い合わせ</h2>
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSfEAEWstoZZmx_Gyc8JL-uM-8npguBxA1b4Ul5fiqZBTq8v1Q/viewform?usp=header"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-500 underline hover:no-underline text-sm"
            >
              お問い合わせフォーム
            </a>
          </section>
        </div>
      </div>
    </>
  );
}
